var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSquareLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "arrow-circle-down",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,0H4.5C2.019,0,0,2.019,0,4.5v15c0,2.481,2.019,4.5,4.5,4.5h15c2.481,0,4.5-2.019,4.5-4.5V4.5c0-2.481-2.019-4.5-4.5-4.5Zm3.5,19.5c0,1.93-1.57,3.5-3.5,3.5H4.5c-1.93,0-3.5-1.57-3.5-3.5V4.5c0-1.93,1.57-3.5,3.5-3.5h15c1.93,0,3.5,1.57,3.5,3.5v15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,11.5H7.096c.063-.177,.155-.345,.287-.493,.266-.301,.527-.587,.717-.777l2.828-2.879c.194-.197,.191-.514-.006-.708-.198-.193-.515-.191-.707,.006l-2.825,2.876c-.198,.198-.475,.5-.756,.818-.837,.944-.837,2.368,0,3.312,.282,.318,.559,.621,.753,.815l2.828,2.879c.098,.1,.227,.149,.356,.149,.126,0,.253-.048,.351-.143,.197-.194,.2-.51,.006-.708l-2.831-2.882c-.187-.187-.448-.473-.715-.774-.131-.148-.224-.316-.286-.493h10.404c.276,0,.5-.224,.5-.5s-.224-.5-.5-.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSquareLeft);
export default __webpack_public_path__ + "static/media/arrow-square-left.3132b758e75eedf5c55487ca77af38ce.svg";
export { ForwardRef as ReactComponent };